const normalize = (text) => {
    text = text.replace(/\r\n/g, '\n');
    if (text.charCodeAt(0) === 0xFEFF)
        text = text.slice(1);
    return text;
};
export default normalize;
